// file created at 2020-2-1
// Auto-generated files D3Dendrogram.ts

import { Vue, Component } from 'vue-property-decorator';
import * as d3 from 'd3';
import _ from 'lodash';
import data from '@/data/d3basic-19983881105_e93c2d8279_b.jpg.json';

import {
  getHeight,
  getHeightDifference,
  getRgbColor,
  isBalanced,
  rotate
} from '@/utils/tree-utils';

@Component({})
export default class D3Dendrogram extends Vue {
  private width: number = 6000;
  private margin: number = 50;

  private mounted() {
    const root: any = this.tree(data);

    const svg = d3
      .select('.d3dendrogram')
      .append('svg')
      .attr('width', this.width)
      .attr('height', this.width);

    const link = svg
      .append('g')
      .attr('fill', 'none')
      .attr('stroke', '#555')
      .attr('stroke-opacity', 0.4)
      .attr('stroke-width', 1.5)
      .selectAll('path')
      .data(root.links())
      .join('path')
      .attr(
        'd',
        (d: any) => `
        M${d.target.x + this.width / 2},${d.target.y + this.margin}
        C${d.target.x + this.width / 2},${d.source.y +
          root.dx / 2 +
          this.margin}
         ${d.source.x + this.width / 2},${d.source.y +
          root.dx / 2 +
          this.margin}
         ${d.source.x + this.width / 2},${d.source.y + this.margin}
      `
      );

    const node = svg
      .append('g')
      .attr('stroke-linejoin', 'round')
      .attr('stroke-width', 3)
      .selectAll('g')
      .data(root.descendants())
      .join('g')
      .attr(
        'transform',
        (d: any) => `translate(${d.x + this.width / 2},${d.y + this.margin})`
      );

    node
      .append('circle')
      .attr('fill', (d: any) => (d.children ? '#555' : '#999'))
      .attr('fill', getRgbColor)
      .attr('r', 5);

    node
      .append('text')
      // .attr('dx', '0.31em')
      .attr('y', (d: any) => (d.children ? -8 : 18))
      .text((d: any) => d.data.name)
      // .filter((d: any) => d.children)
      .attr('text-anchor', 'middle')
      .clone(true)
      .lower()
      .attr('stroke', 'white');
  }

  // tslint:disable-next-line: no-shadowed-variable
  private tree = data => {
    const root: any = d3
      .hierarchy(data)
      .sort(
        (a, b) =>
          d3.descending(a.height, b.height) ||
          d3.ascending(a.data.name, b.data.name)
      );
    root.dx = 20;
    // root.dy = this.width / (root.height + 1);
    root.dy = 40;
    return d3.cluster().nodeSize([root.dx, root.dy])(root);
    // tslint:disable-next-line: semicolon
  };
}
